import { ICalendarEventMinimumData } from '@/components/week-calendar/types/ICalendarEvent';
import { formatDate } from '@/services/date-formatter.service';
import { Box } from '@chakra-ui/react';

export interface IWeekCalendarEventProps<TEvent> {
	event: TEvent;
}

export default function WeekCalendarEvent<TEvent extends ICalendarEventMinimumData>(
	props: IWeekCalendarEventProps<TEvent>
) {
	return (
		<Box
			cursor="pointer"
			w="full"
			h="full"
			borderColor="black"
			borderWidth={0.5}
			p={0}
			overflow="hidden"
			textOverflow="ellipsis"
			whiteSpace="nowrap"
			wordBreak="break-all"
			shadow="md"
			fontSize="x-small"
			zIndex={1}
		>
			{formatDate({
				date: new Date(props.event.start.toInstant().epochMilliseconds),
				hour: '2-digit',
				minute: '2-digit',
			})}{' '}
			-{' '}
			{formatDate({
				date: new Date(props.event.end.toInstant().epochMilliseconds),
				hour: '2-digit',
				minute: '2-digit',
			})}
		</Box>
	);
}
